// crewbit-admin/src/components/money/StrandedMutationBanner.tsx
//
// Mirrors crewbit-mobile/components/money/StrandedMutationBanner.tsx.
// Admin's queue substrate is deferred (§AdminOfflineQueue), so count is
// always 0 today and this component never renders. Wired into FinancialsPage
// proactively so the carry-forward to admin queue support is one-line.

import { Link } from 'react-router-dom';
import { useStrandedMutations } from '../../hooks/useStrandedMutations';

export default function StrandedMutationBanner() {
  const { count, isLoading } = useStrandedMutations();

  if (isLoading) return null;
  if (count === 0) return null;

  const label = count === 1 ? `1 item couldn't sync.` : `${count} items couldn't sync.`;

  return (
    <Link
      to="/settings/sync-issues"
      aria-label={`${label} View sync issues.`}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        background: '#FEF3C7',
        color: '#92400E',
        padding: '10px 16px',
        borderRadius: 8,
        fontWeight: 600,
        textDecoration: 'none',
        fontSize: 14,
      }}
    >
      <span aria-hidden style={{ fontSize: 16 }}>☁︎</span>
      <span style={{ flex: 1 }}>{label}</span>
      <span style={{ fontWeight: 700 }}>View →</span>
    </Link>
  );
}
